import { Form, Input, Select } from "antd";
import React from "react";
import { useContext } from "react";
import ExpertProfessionsContext from "../../../../../context/expertProffessionsContext";
import ExpertDataContext from "../../../../../context/expertDataContext";

function ProfessionsModal({ data, professionsOptions, defaults }) {
  const {
    comprehensiveProfessionsIdsAction,
    farmingIdsAction,
    greenHouseIdsAction,
    liveStockIdsAction,
    veterinaryIdsAction,
  } = useContext(ExpertProfessionsContext);

  const { expertDataAction } = useContext(ExpertDataContext)

  //defaults
  const defaultCP = defaults?.defaultCP;
  const defaultFarming = defaults?.defaultFarming;
  const defaultGreenHouse = defaults?.defaultGreenHouse;
  const defaultLiveStock = defaults?.defaultLiveStock;
  const defaultVeterinary = defaults?.defaultVeterinary;
  //comprehensive professions default value and options

  const comprehensiveProfessionsOptions = professionsOptions
    ?.filter(
      (item) => item?.categoryEN === "PROFESSIONS_COMPREHENSIVE_PROFESSIONS"
    )
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //farming default value and options

  const farmingOptions = professionsOptions
    ?.filter((item) => item?.categoryEN === "PROFESSIONS_FARMS_AND_GARDENS")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //greenHouse default value and options

  const greenHouseOptions = professionsOptions
    ?.filter((item) => item?.categoryEN === "PROFESSIONS_GREENHOUSE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //liveStock default value and options

  const liveStockOptions = professionsOptions
    ?.filter((item) => item?.categoryEN === "PROFESSIONS_LIVESTOCK_POULTRY")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //Veterinary default value and options

  const veterinaryOptions = professionsOptions
    ?.filter((item) => item?.categoryEN === "PROFESSIONS_VETERINARY_MEDICINE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //Veterinary default value
  const defaultOtherProfessions = data?.otherProfessions;

  const handleChange = (e) => {
    expertDataAction(e?.target?.name, e?.target?.value);
  };

  const changeHanlder1 = (value) => {
    comprehensiveProfessionsIdsAction(value);
  };
  const changeHanlder2 = (value) => {
    farmingIdsAction(value);
  };
  const changeHanlder3 = (value) => {
    greenHouseIdsAction(value);
  };
  const changeHanlder4 = (value) => {
    liveStockIdsAction(value);
  };
  const changeHanlder5 = (value) => {
    veterinaryIdsAction(value);
  };

  return (
    <Form layout="vertical">
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label="حرف جامع" className="w-1/2 max-lg:w-full">
          <Select
            options={comprehensiveProfessionsOptions}
            className="font-body "
            defaultValue={defaultCP}
            mode="multiple"
            onChange={changeHanlder1}
            clearIcon
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="زراعت و باغ" className="w-1/2 max-lg:w-full">
          <Select
            options={farmingOptions}
            className="font-body "
            defaultValue={defaultFarming}
            mode="multiple"
            onChange={changeHanlder2}
            clearIcon
            showSearch={false}
          />
        </Form.Item>
      </section>
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label="گلخانه" className="w-1/2 max-lg:w-full">
          <Select
            options={greenHouseOptions}
            className="font-body "
            defaultValue={defaultGreenHouse}
            mode="multiple"
            onChange={changeHanlder3}
            clearIcon
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="دام و طیور" className="w-1/2 max-lg:w-full">
          <Select
            options={liveStockOptions}
            className="font-body "
            defaultValue={defaultLiveStock}
            mode="multiple"
            onChange={changeHanlder4}
            clearIcon
            showSearch={false}
          />
        </Form.Item>
      </section>
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label="دامپزشکی" className="w-1/2 max-lg:w-full">
          <Select
            options={veterinaryOptions}
            className="font-body "
            defaultValue={defaultVeterinary}
            mode="multiple"
            onChange={changeHanlder5}
            clearIcon
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="سایر حرفه ها" className="w-1/2 max-lg:w-full">
          <Input
            defaultValue={defaultOtherProfessions}
            placeholder="اگر حرفه مورد نظر شما در لیست های بالا نبود در این قسمت وارد کنید..."
            onChange={handleChange}
            name="otherProfessions"
          />
        </Form.Item>
      </section>
    </Form>
  );
}

export default ProfessionsModal;
